import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import { pushLoginExpressDeliveryOptionClickEventToDataLayer } from '../../data-layer.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import '@grandvisionhq/state';
import '../../StepShipping/selectors.js';
import '@grandvisionhq/auth';
import '../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../mappers/errors-mapping.js';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/set-store.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import { ShippingMethod } from '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import { useSetShippingMethod } from '../../hooks/operations/use-set-shipping-method.js';
import { useSetStore } from '../../hooks/operations/use-set-store.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../operations/fragments/checkout-mutation-result.js';
import '../../operations/fragments/cart-mutation-failures.js';
import '../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../operations/fragments/paypal-payment.js';
import '../../operations/fragments/saved-user-details.js';
import '../../operations/queries/get-checkout-state.js';
import '../../operations/queries/get-user-details.js';
import { useShippingMethodsList } from '../../StepShipping/modules/ShippingMethods/hooks/use-shipping-methods-list.js';
import { useLoggedInCheckout } from '../context/context.js';
import '@grandvisionhq/lib-utils-w3c';

const useShippingStateConfig = ()=>{
    var ref1;
    const { cart  } = Context.useCart();
    const cartShippingMethod = cart === null || cart === void 0 ? void 0 : cart.shippingMethod;
    const { shippingState , setShippingState , selectedShippingMethod , isUserLoggedIn  } = useLoggedInCheckout();
    const { shipping  } = useCheckoutSettings();
    const [selectedStore, setSelectedStore] = React.useState(()=>{
        if (shippingState.store) {
            return shippingState.store;
        }
        return undefined;
    });
    const [selectedPickupPoint, setSelectedPickupPoint] = React.useState(()=>{
        if (shippingState.pickupPoint) {
            return shippingState.pickupPoint;
        }
        return undefined;
    });
    const isPickUpOption = React.useCallback((option)=>option === ShippingMethod.Pickup || option === ShippingMethod.PickupPoint
    , []);
    const { setStore  } = useSetStore();
    /**
   *  Success handler for shippingMethodForCart query operation
   */ const onShippingMethodsLoadCompleted = React.useCallback((shippingMethodList)=>{
        const isSelectedShippingMethodValid = shippingMethodList.find((method)=>selectedShippingMethod.method == method.key
        );
        if (selectedShippingMethod.method && !isSelectedShippingMethodValid) {
            setShippingState(swcHelpers.objectSpread({}, shippingState, {
                selectedShippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: true
                }
            }));
        } else if (!selectedShippingMethod.method && (shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod)) {
            setShippingState(swcHelpers.objectSpread({}, shippingState, {
                selectedShippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: false
                }
            }));
        } else if (cartShippingMethod && cartShippingMethod.key !== selectedShippingMethod.method) {
            if (cartShippingMethod.key) {
                setShippingState(swcHelpers.objectSpread({}, shippingState, {
                    selectedShippingMethod: {
                        method: cartShippingMethod.key,
                        isValid: true,
                        isTouched: false
                    },
                    isPickupOrder: isPickUpOption(cartShippingMethod.key)
                }));
            } else {
                // Cart has no shipping method information, try to use the actual default value
                // This happens when a feature toggle in cart-service (ADD_SHIPPING_METHOD_TO_CART) is disabled
                const defaultShippingMethod = shippingMethodList.find((method)=>method.isDefault
                );
                if (defaultShippingMethod) {
                    setShippingState(swcHelpers.objectSpread({}, shippingState, {
                        selectedShippingMethod: {
                            method: defaultShippingMethod.key,
                            isValid: true,
                            isTouched: false
                        },
                        isPickupOrder: isPickUpOption(defaultShippingMethod.key)
                    }));
                }
            }
        }
    }, [
        cartShippingMethod,
        isPickUpOption,
        selectedShippingMethod.method,
        setShippingState,
        shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod,
        shippingState, 
    ]);
    const { shippingMethodList: shippingMethodList1 , reloadShippingMethods , isLoading: shippingOptionsLoading , error: shippingOptionsError ,  } = useShippingMethodsList(onShippingMethodsLoadCompleted);
    const onShippingMethodError = React.useCallback(()=>{
        reloadShippingMethods();
    }, [
        reloadShippingMethods
    ]);
    const { setShippingMethod  } = useSetShippingMethod({
        onError: onShippingMethodError
    });
    const validateStoreSelection = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        var ref;
        if ((selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code) !== (cart === null || cart === void 0 ? void 0 : (ref = cart.serviceStore) === null || ref === void 0 ? void 0 : ref.code)) {
            (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code) && (yield setStore(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code));
        }
    }), [
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.serviceStore) === null || ref1 === void 0 ? void 0 : ref1.code,
        selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code,
        setStore
    ]);
    const getLocationId = React.useCallback((shippingOption)=>{
        switch(shippingOption){
            case ShippingMethod.Pickup:
                return selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.globalStoreId;
            case ShippingMethod.PickupPoint:
                return selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.globalPickupPointId;
            default:
                return undefined;
        }
    }, [
        selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.globalStoreId,
        selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.globalPickupPointId
    ]);
    const handleShippingOptionSelection = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(shippingOption) {
            if (!shippingMethodList1 || shippingMethodList1.length < 0) {
                throw new Error('No shipping methods available!');
            }
            const shippingMethod = shippingMethodList1.find((item)=>item.key === shippingOption
            );
            const isPickupOption = isPickUpOption(shippingOption);
            const isValidPickUpInStore = shippingOption === ShippingMethod.Pickup && selectedStore;
            if (!shippingMethod) {
                console.warn('Partially unsupported shipping method selected, attempting to select it');
            } else {
                // update the shipping method on the cart
                const locationId = getLocationId(shippingOption);
                if (isValidPickUpInStore && locationId) {
                    yield setShippingMethod(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id, locationId);
                }
                setShippingState(swcHelpers.objectSpread({}, shippingState, {
                    selectedShippingMethod: {
                        method: shippingOption,
                        isValid: true,
                        isTouched: true
                    },
                    isPickupOrder: isPickupOption
                }));
                if (isValidPickUpInStore) {
                    validateStoreSelection();
                }
                pushLoginExpressDeliveryOptionClickEventToDataLayer({
                    shippingMethod: shippingOption,
                    isLoggedIn: isUserLoggedIn
                });
            }
        });
        return function(shippingOption) {
            return _ref.apply(this, arguments);
        };
    }(), [
        shippingMethodList1,
        isPickUpOption,
        selectedStore,
        getLocationId,
        setShippingState,
        shippingState,
        isUserLoggedIn,
        setShippingMethod,
        validateStoreSelection, 
    ]);
    const onPickUpPointOrStoreModelClosed = React.useCallback(()=>{
        if (!shippingMethodList1 || shippingMethodList1.length < 0 || !cartShippingMethod) {
            throw new Error('No shipping methods available!');
        }
        if (selectedShippingMethod.method === ShippingMethod.Pickup && !selectedStore || selectedShippingMethod.method === ShippingMethod.PickupPoint && !selectedPickupPoint) {
            setShippingState(swcHelpers.objectSpread({}, shippingState, {
                isPickupOrder: isPickUpOption(cartShippingMethod === null || cartShippingMethod === void 0 ? void 0 : cartShippingMethod.key),
                selectedShippingMethod: swcHelpers.objectSpread({}, shippingState.selectedShippingMethod, {
                    method: cartShippingMethod === null || cartShippingMethod === void 0 ? void 0 : cartShippingMethod.key
                })
            }));
        }
    }, [
        cartShippingMethod,
        isPickUpOption,
        selectedPickupPoint,
        selectedShippingMethod.method,
        selectedStore,
        setShippingState,
        shippingMethodList1,
        shippingState, 
    ]);
    const handlePickupStoreSelection = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(store) {
            if (!shippingMethodList1 || shippingMethodList1.length < 0) {
                throw new Error('No shipping methods available!');
            }
            const shippingMethod = shippingMethodList1.find((item)=>item.key === ShippingMethod.Pickup
            );
            if (!shippingMethod) {
                console.warn('Partially unsupported shipping method selected, attempting to select it');
            } else {
                yield setShippingMethod(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id, store.globalStoreId);
            }
            setStore(store.code);
            setSelectedStore(store);
            setShippingState(swcHelpers.objectSpread({}, shippingState, {
                selectedShippingMethod: {
                    method: shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.key,
                    isValid: true,
                    isTouched: true
                },
                store,
                isPickupOrder: true
            }));
        });
        return function(store) {
            return _ref.apply(this, arguments);
        };
    }(), [
        shippingMethodList1,
        setStore,
        setShippingState,
        shippingState,
        setShippingMethod
    ]);
    const handlePickupPointSelection = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(pickupPoint) {
            if (!shippingMethodList1 || shippingMethodList1.length < 0) {
                throw new Error('No shipping methods available!');
            }
            const shippingMethod = shippingMethodList1.find((item)=>item.key === ShippingMethod.PickupPoint
            );
            if (!shippingMethod) {
                console.warn('Partially unsupported shipping method selected, attempting to select it');
            } else {
                yield setShippingMethod(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id);
            }
            setSelectedPickupPoint(pickupPoint);
            setShippingState(swcHelpers.objectSpread({}, shippingState, {
                selectedShippingMethod: {
                    method: shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.key,
                    isValid: true,
                    isTouched: true
                },
                pickupPoint,
                isPickupOrder: true
            }));
        });
        return function(pickupPoint) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setShippingMethod,
        setShippingState,
        shippingMethodList1,
        shippingState
    ]);
    React.useEffect(()=>{
        if (!selectedShippingMethod.isTouched && selectedShippingMethod.isValid && (shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod)) {
            setShippingState(swcHelpers.objectSpread({}, shippingState, {
                selectedShippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: false
                }
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedShippingMethod,
        shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod
    ]);
    return React.useMemo(()=>({
            shippingMethodList: shippingMethodList1,
            selectedShippingMethod,
            shippingOptionsLoading,
            shippingOptionsError,
            handleShippingOptionSelection,
            selectedPickupPoint,
            selectedStore,
            onStoreSelect: handlePickupStoreSelection,
            onPickupPointSelect: handlePickupPointSelection,
            onShippingModalClose: onPickUpPointOrStoreModelClosed
        })
    , [
        shippingMethodList1,
        selectedShippingMethod,
        shippingOptionsLoading,
        shippingOptionsError,
        handleShippingOptionSelection,
        selectedPickupPoint,
        selectedStore,
        handlePickupStoreSelection,
        handlePickupPointSelection,
        onPickUpPointOrStoreModelClosed, 
    ]);
};

export { useShippingStateConfig };
//# sourceMappingURL=useShippingStateConfig.js.map
